import React from 'react';
import ButtonsVariant from '../Components/Button/ButtonVariant'; // Fixed: Use default import

const Buton = () => (
  <div className="flex flex-wrap items-center gap-4 p-4">
    <div>
        {/* Black-to-White Variants (Litho-inspired, pill-shaped) */}
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="blackToWhite"
      size="xl"
      title="Button Extra Large"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="blackToWhite"
      size="lg"
      title="Button large"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="blackToWhite"
      size="md"
      title="Button medium"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="blackToWhite"
      size="sm"
      title="Button small"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="blackToWhite"
      size="xs"
      title="Very Small"
    />
    </div>
  
<div>
     {/* White-to-Black Variants (Litho-inspired, pill-shaped) */}
     <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="whiteToBlack"
      size="xl"
      title="Button Extra Large"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="whiteToBlack"
      size="lg"
      title="Button large"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="whiteToBlack"
      size="md"
      title="Button medium"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="whiteToBlack"
      size="sm"
      title="Button small"
    />
    <ButtonsVariant
      ariaLabel="button"
      href="#"
      className="mx-[10px]"
      variant="whiteToBlack"
      size="xs"
      title="Very Small"
    />
</div>
 
  </div>
);

export default Buton;